<div class="container">
  @if (blockedUi) {
  <div class="fp-block-ui-overlay" aria-live="polite" aria-busy="true">
    <i class="pi pi-spin pi-spinner" style="font-size: 60px;font-weight: bold"></i>
  </div>
  }

  <div class="grid">
    <div class="col-12">
      <h2 class="page-title">{{ 'TRANSLATE.MANAGE.CONTRACTS.EDIT' | translate }}</h2>
    </div>

    <div class="col-12">
      <p-accordion [multiple]="true" [(activeIndex)]="accordionActiveIndices">
        <p-accordionTab header="{{ 'TRANSLATE.CLIENT.DATA' | translate }}">
          <div class="grid ui-fluid">

            <!-- Linha 1: Nome completo (campos largos) -->
            <div class="col-12 md:col-6">
              <label class="filtro" for="customerNameEdit">
                {{ 'TRANSLATE.TWO.POINTS.NAME' | translate }}
              </label><br />
              <input pInputText [disabled]="isEditBlockDisabled" id="customerNameEdit"
                [(ngModel)]="filterContractSearchResult.customerName" type="text" maxlength="100"
                [title]="filterContractSearchResult.customerName || ''" style="width: 100%" />
            </div>

            <div class="col-12 md:col-6">
              <label class="filtro" for="customerLastNameEdit">{{ 'TRANSLATE.TWO.POINTS.LAST.NAME' | translate
                }}</label><br />
              <input pInputText [disabled]="isEditBlockDisabled" id="customerLastNameEdit"
                [(ngModel)]="filterContractSearchResult.customerLastName" type="text" maxlength="50"
                [title]="filterContractSearchResult.customerLastName || ''" style="width: 100%" />
            </div>

            <!-- Linha 2: Identificação e contato (3 por linha) -->
            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="customerDoc">{{ 'TRANSLATE.TWO.POINTS.CPF.CNPJ' | translate }}</label><br />
              <input pInputText [disabled]="isEditBlockDisabled" id="customerDoc"
                [(ngModel)]="filterContractSearchResult.customerDocument" (ngModelChange)="onDocumentInput($event)"
                type="text" maxlength="20" [title]="filterContractSearchResult.customerDocument || ''"
                style="width: 100%" />
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="customerEmailEdit">{{ 'TRANSLATE.TWO.POINTS.EMAIL' | translate }}</label><br />
              <input [disabled]="isEditDisabled" [(ngModel)]=" editingCustomerEmail"
                (ngModelChange)="onCustomerEmailInput($event)" type="email" name="email" [email]="validateEmail"
                #prmEmail="ngModel" id="customerEmailEdit" maxlength="50" style="width: 100%" required pInputText />
              <span class="char-counter">{{ 'TRANSLATE.CLIENT.DATA.CHARACTER.COUNTER' | translate:{ current:
                (editingCustomerEmail?.length || 0), max: 50 } }}</span>
              @if (prmEmail.errors?.email) {
              <p-message class="client-data-message" severity="error"
                text="{{ 'TRANSLATE.INVALID.EMAIL' | translate }}">
              </p-message>
              }
              @if (isEditingMode && requiredCustomerEmail === true && !editingCustomerEmail) {
              <p-message class="client-data-message" severity="error"
                text="{{ 'TRANSLATE.ENTER.THE.VALUE.OF.THE.FIELD' | translate }}">
              </p-message>
              }
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="customerPhoneEdit">{{ 'TRANSLATE.TWO.POINTS.PHONE' | translate }}</label><br />
              <input pInputText [disabled]="isEditBlockDisabled" id="customerPhoneEdit"
                [(ngModel)]="filterContractSearchResult.customerPhone" (ngModelChange)="onPhoneInput($event)"
                type="text" maxlength="14" style="width: 100%" />
            </div>

            <!-- Linha 3: CEP / Endereço / Número -->
            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="customerCepEdit">{{ 'TRANSLATE.TWO.POINTS.CEP' | translate }}</label><br />
              <input pInputText [disabled]="isEditBlockDisabled" id="customerCepEdit"
                [(ngModel)]="filterContractSearchResult.customerCep" (ngModelChange)="onCepInput($event)" type="text"
                maxlength="20" style="width: 100%" />
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="customerAddressEdit">{{ 'TRANSLATE.TWO.POINTS.ADDRESS' | translate
                }}</label><br />
              <input pInputText [disabled]="isEditBlockDisabled" id="customerAddressEdit"
                [(ngModel)]="filterContractSearchResult.customerAddress" type="text" maxlength="200"
                style="width: 100%" />
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="customerAddressNumberEdit">{{ 'TRANSLATE.TWO.POINTS.NUMBER.WRITTEN' | translate
                }}</label><br />
              <input pInputText [disabled]="isEditBlockDisabled" id="customerAddressNumberEdit"
                [(ngModel)]="filterContractSearchResult.customerAddressNumber" type="text" maxlength="20"
                style="width: 100%" />
            </div>

            <!-- Linha 4: Complemento / Bairro / Cidade -->
            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="customerAddressCompEdit">{{ 'TRANSLATE.TWO.POINTS.COMPLEMENT' | translate
                }}</label><br />
              <input pInputText [disabled]="isEditBlockDisabled" id="customerAddressCompEdit"
                [(ngModel)]="filterContractSearchResult.customerAddressComp" type="text" maxlength="100"
                style="width: 100%" />
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="customerAddressDistrictEdit">{{ 'TRANSLATE.TWO.POINTS.SURROUND' | translate
                }}</label><br />
              <input pInputText [disabled]="isEditBlockDisabled" id="customerAddressDistrictEdit"
                [(ngModel)]="filterContractSearchResult.customerAddressDistrict" type="text" maxlength="100"
                style="width: 100%" />
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="customerAddressCityEdit">{{ 'TRANSLATE.TWO.POINTS.CITY' | translate
                }}</label><br />
              <input pInputText [disabled]="isEditBlockDisabled" id="customerAddressCityEdit"
                [(ngModel)]="filterContractSearchResult.customerAddressCity" type="text" maxlength="100"
                style="width: 100%" />
            </div>

            <!-- Linha 5: Estado -->
            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="customerAddressStateEdit">{{ 'TRANSLATE.TWO.POINTS.STATE' | translate
                }}</label><br />
              <input pInputText [disabled]="isEditBlockDisabled" id="customerAddressStateEdit"
                [(ngModel)]="filterContractSearchResult.customerAddressState" type="text" maxlength="30"
                style="width: 100%" />
            </div>

          </div>
        </p-accordionTab>

        <p-accordionTab header="{{ 'TRANSLATE.DEALER.DETAILS' | translate }}">
          <div class="grid ui-fluid">
            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="dealerCodeEdit">{{ 'TRANSLATE.TWO.POINTS.CODE' |
                translate}}</label><br />
              <input pInputText [disabled]="isEditBlockDisabled" id="dealerCodeEdit"
                [(ngModel)]="filterContractSearchResult.dnPac" type="text" maxlength="20" style="width: 100%" />
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="dealerNameEdit">{{ 'TRANSLATE.TWO.POINTS.NAME.RS.CONTRACT' |
                translate
                }}</label><br />
              <input pInputText [disabled]="isEditBlockDisabled" id="dealerNameEdit"
                [(ngModel)]="filterContractSearchResult.dnName" type="text" maxlength="100" style="width: 100%" />
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="dealerEmailEdit">{{ 'TRANSLATE.TWO.POINTS.EMAIL' | translate
                }}</label><br />
              <input pInputText [disabled]="isEditBlockDisabled" id="dealerEmailEdit"
                [(ngModel)]="filterContractSearchResult.dnEmail" type="text" maxlength="50" style="width: 100%" />
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="dealerPhoneEdit">{{ 'TRANSLATE.TWO.POINTS.PHONE' | translate
                }}</label><br />
              <input pInputText [disabled]="isEditBlockDisabled" id="dealerPhoneEdit"
                [(ngModel)]="filterContractSearchResult.dnPhone" (ngModelChange)="onDealerPhoneInput($event)"
                type="text" maxlength="14" style="width: 100%" />
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="dealerCityEdit">{{ 'TRANSLATE.TWO.POINTS.CITY' | translate
                }}</label><br />
              <input pInputText [disabled]="isEditBlockDisabled" id="dealerCityEdit"
                [(ngModel)]="filterContractSearchResult.dnCity" type="text" maxlength="100" style="width: 100%" />
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="sellerCodeEdit">{{ 'TRANSLATE.TWO.POINTS.SELLER.CODE' | translate
                }}</label><br />
              <input pInputText [disabled]="isEditBlockDisabled" id="sellerCodeEdit"
                [(ngModel)]="filterContractSearchResult.sellerCode" type="text" maxlength="20" style="width: 100%" />
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="sellerNameEdit">{{ 'TRANSLATE.TWO.POINTS.SALESMAN.NAME' |
                translate }}</label><br />
              <input pInputText [disabled]="isEditBlockDisabled" id="sellerNameEdit"
                [(ngModel)]="filterContractSearchResult.sellerName" type="text" maxlength="100" style="width: 100%" />
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="sellerEmailEdit">{{ 'TRANSLATE.TWO.POINTS.SALESMAN.EMAIL' |
                translate }}</label><br />
              <input pInputText [disabled]="isEditBlockDisabled" id="sellerEmailEdit"
                [(ngModel)]="filterContractSearchResult.sellerEmail" type="text" maxlength="50" style="width: 100%" />
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="sellerPhoneEdit">{{ 'TRANSLATE.TWO.POINTS.SALESMAN.PHONE' |
                translate }}</label><br />
              <input pInputText [disabled]="isEditBlockDisabled" id="sellerPhoneEdit"
                [(ngModel)]="filterContractSearchResult.sellerPhone" (ngModelChange)="onSellerPhoneInput($event)"
                type="text" maxlength="14" style="width: 100%" />
            </div>
          </div>
        </p-accordionTab>

        <p-accordionTab header="{{ 'TRANSLATE.CONTRACT.DATA' | translate }}">
          <div class="grid ui-fluid">

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="originalContractNumberEdit">{{
                'TRANSLATE.TWO.POINTS.ORIGINAL.CONTRACT.NUMBER' | translate
                }}</label><br />
              <input pInputText [disabled]="isEditBlockDisabled" id="originalContractNumberEdit"
                [(ngModel)]="filterContractSearchResult.contractNumber" type="text" maxlength="30"
                style="width: 100%" />
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="fp2ContractNumberEdit">{{
                'TRANSLATE.TWO.POINTS.FP2.CONTRACT.NUMBER' | translate
                }}</label><br />
              <input pInputText [disabled]="isEditBlockDisabled" id="fp2ContractNumberEdit"
                [(ngModel)]="filterContractSearchResult.contractCodeFp2" type="text" maxlength="30"
                style="width: 100%" />
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="countryEdit">{{ 'TRANSLATE.TWO.POINTS.COUNTRY' | translate
                }}</label><br />
              <input pInputText [disabled]="isEditBlockDisabled" id="countryEdit"
                [(ngModel)]="filterContractSearchResult.country" type="text" maxlength="3" style="width: 100%" />
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="contractStatusEdit">{{ 'TRANSLATE.TWO.POINTS.CONTRACT.STATUS' |
                translate }}</label><br />
              <p-dropdown [disabled]="isEditDisabled" [(ngModel)]="editingContractStatusCode"
                (onChange)="onContractStatusChange($event)" placeholder="{{ 'TRANSLATE.SELECT' | translate }}"
                id="contractStatusEdit" [options]="statusContract" [style]="{'minWidth':'100%'}">
                <ng-template pTemplate="item" let-item>
                  {{item?.label | translate}}
                </ng-template>
                <ng-template pTemplate="selectedItem" let-item>
                  {{ item?.label ? (item.label | translate) : ('TRANSLATE.SELECT' | translate) }}
                </ng-template>
              </p-dropdown>

              @if (isEditingMode && hasAttemptedSave && requiredContractStatusCode === true &&
              !editingContractStatusCode) {
              <p-message class="client-data-message" severity="error"
                text="{{ 'TRANSLATE.ENTER.THE.VALUE.OF.THE.FIELD' | translate }}">
              </p-message>
              }
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="chassisStatusEdit">{{ 'TRANSLATE.TWO.POINTS.CHASSIS.STATUS' |
                translate }}</label><br />
              <p-dropdown [disabled]="isEditBlockDisabled" id="chassisStatusEdit"
                placeholder="{{ 'TRANSLATE.SELECT' | translate }}"
                [(ngModel)]="filterContractSearchResult.vinStatusCode" [options]="statusContract"
                [style]="{'minWidth':'100%'}">
                <ng-template pTemplate="item" let-item>
                  {{item?.label | translate}}
                </ng-template>
                <ng-template pTemplate="selectedItem" let-item>
                  {{ item?.label ? (item.label | translate) : ('TRANSLATE.SELECT' | translate) }}
                </ng-template>
              </p-dropdown>
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="saleTypeEdit">{{ 'TRANSLATE.TWO.POINTS.SALE.TYPE' | translate
                }}</label><br />
              <input pInputText [disabled]="isEditBlockDisabled" id="saleTypeEdit" [(ngModel)]="salesTypeFord"
                type="text" maxlength="30" style="width: 100%" />
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="chassisNumberEdit">{{ 'TRANSLATE.TWO.POINTS.CHASSI.NUMBER' |
                translate }}</label><br />
              <input pInputText [disabled]="isEditBlockDisabled" id="chassisNumberEdit"
                [(ngModel)]="filterContractSearchResult.vin" type="text" maxlength="17" style="width: 100%" />
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="wsdDateEdit">{{ 'TRANSLATE.TWO.POINTS.DATA.WSD' | translate
                }}</label><br />
              <p-calendar [readonlyInput]="true" [disabled]="isEditDisabled" id="wsdDateEdit"
                [(ngModel)]="filterContractSearchResult.wsd" dateFormat="dd/mm/yy"
                (ngModelChange)="onWsdDateChange($event)" [style]="{'width':'100%'}"
                [inputStyle]="{'width':'100%'}"></p-calendar>

              @if (isEditingMode && hasAttemptedSave && requiredWsdDate === true && !filterContractSearchResult.wsd) {
              <p-message class="client-data-message" severity="error"
                text="{{ 'TRANSLATE.ENTER.THE.VALUE.OF.THE.FIELD' | translate }}">
              </p-message>
              }
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="vinSaleDateEdit">{{ 'TRANSLATE.TWO.POINTS.DATE.OF.SALE' |
                translate }}</label><br />
              <p-calendar [readonlyInput]="true" [disabled]="isEditBlockDisabled" id="vinSaleDateEdit"
                [(ngModel)]="filterContractSearchResult.vinSaleDate" dateFormat="dd/mm/yy" [style]="{'width':'100%'}"
                [inputStyle]="{'width':'100%'}"></p-calendar>
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="vinStartDateEdit">{{
                'TRANSLATE.TWO.POINTS.START.DATE.OF.CHASSIS.IN.CONTRACT' |
                translate }}</label><br />
              <p-calendar [readonlyInput]="true" [disabled]="isEditBlockDisabled" id="vinStartDateEdit"
                [(ngModel)]="filterContractSearchResult.vinStartDate" dateFormat="dd/mm/yy" [style]="{'width':'100%'}"
                [inputStyle]="{'width':'100%'}"></p-calendar>
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="vinEndDateEdit">{{
                'TRANSLATE.TWO.POINTS.END.DATE.OF.CHASSIS.IN.CONTRACT' | translate
                }}</label><br />
              <p-calendar [readonlyInput]="true" [disabled]="isEditBlockDisabled" id="vinEndDateEdit"
                [(ngModel)]="filterContractSearchResult.vinEndDate" dateFormat="dd/mm/yy" [style]="{'width':'100%'}"
                [inputStyle]="{'width':'100%'}"></p-calendar>
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="coverageStartDateEdit">{{
                'TRANSLATE.TWO.POINTS.COVERAGE.START.DATE' | translate
                }}</label><br />
              <p-calendar [readonlyInput]="true" [disabled]="isEditDisabled" id="coverageStartDateEdit"
                [(ngModel)]="filterContractSearchResult.coverageStartDate" [ngModelOptions]="{standalone: true}"
                dateFormat="dd/mm/yy" (ngModelChange)="onCoverageStartDateChange($event)" [style]="{'width':'100%'}"
                [inputStyle]="{'width':'100%'}"></p-calendar>

              @if (isEditingMode && hasAttemptedSave && requiredCoverageStartDate === true &&
              !filterContractSearchResult.coverageStartDate) {
              <p-message class="client-data-message" severity="error"
                text="{{ 'TRANSLATE.ENTER.THE.VALUE.OF.THE.FIELD' | translate }}">
              </p-message>
              }
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="coverageEndDateEdit">{{
                'TRANSLATE.TWO.POINTS.END.DATE.OF.COVERAGE' | translate
                }}</label><br />
              <p-calendar [readonlyInput]="true" [disabled]="isEditDisabled" id="coverageEndDateEdit"
                [(ngModel)]="filterContractSearchResult.coverageEndDate" [ngModelOptions]="{standalone: true}"
                dateFormat="dd/mm/yy" (ngModelChange)="onCoverageEndDateChange($event)" [style]="{'width':'100%'}"
                [inputStyle]="{'width':'100%'}"></p-calendar>

              @if (isEditingMode && hasAttemptedSave && requiredCoverageEndDate === true &&
              !filterContractSearchResult.coverageEndDate) {
              <p-message class="client-data-message" severity="error"
                text="{{ 'TRANSLATE.ENTER.THE.VALUE.OF.THE.FIELD' | translate }}">
              </p-message>
              }
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="vinActualEndDateEdit">{{
                'TRANSLATE.TWO.POINTS.CHASSIS.CLOSING.DATE' | translate
                }}</label><br />
              <p-calendar [disabled]="isEditBlockDisabled" id="vinActualEndDateEdit"
                [(ngModel)]="filterContractSearchResult.vinActualEndDate" dateFormat="dd/mm/yy"
                [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}"></p-calendar>
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="productCodeEdit">{{ 'TRANSLATE.TWO.POINTS.PRODUCT.CODE' |
                translate }}</label><br />
              <input pInputText [disabled]="isEditBlockDisabled" id="productCodeEdit"
                [(ngModel)]="filterContractSearchResult.productCode" type="text" maxlength="10" style="width: 100%" />
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="productNameEdit">{{ 'TRANSLATE.TWO.POINTS.PRODUCT.NAME' |
                translate }}</label><br />
              <input pInputText [disabled]="isEditBlockDisabled" id="productNameEdit"
                [(ngModel)]="filterContractSearchResult.productName" type="text" maxlength="50" style="width: 100%" />
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="productOriginalNameEdit">{{
                'TRANSLATE.TWO.POINTS.ORIGINAL.PLAN.NAME' | translate
                }}</label><br />
              <input pInputText [disabled]="isEditBlockDisabled" id="productOriginalNameEdit"
                [(ngModel)]="filterContractSearchResult.productOriginalName" type="text" maxlength="50"
                style="width: 100%" />
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="vinCostEdit">{{ 'TRANSLATE.TWO.POINTS.FINAL.CHASSIS.COST' |
                translate
                }}</label><br />
              <input pInputText [disabled]="isEditBlockDisabled" id="vinCostEdit"
                [(ngModel)]="filterContractSearchResult.vinCost" type="text" maxlength="13" style="width: 100%" />
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="contractFinalPriceEdit">{{
                'TRANSLATE.TWO.POINTS.FINAL.CHASSIS.PRICE' | translate
                }}</label><br />

              <p-inputNumber [disabled]="isEditBlockDisabled" id="contractFinalPriceEdit"
                [(ngModel)]="filterContractSearchResult.contractFinalPrice" mode="decimal" [currency]="undefined"
                [locale]="'pt-BR'" [minFractionDigits]="2" [maxFractionDigits]="2" [useGrouping]="true"
                [style]="{'width':'100%','height':'32px','font-size':'16px'}">
              </p-inputNumber>
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="vinSellerPriceEdit">{{
                'TRANSLATE.TWO.POINTS.FINAL.SALESMAN.PRICE' | translate
                }}</label><br />

              <p-inputNumber [disabled]="isEditBlockDisabled" id="vinSellerPriceEdit"
                [(ngModel)]="filterContractSearchResult.vinSellerPrice" mode="decimal" [currency]="undefined"
                [locale]="'pt-BR'" [minFractionDigits]="2" [maxFractionDigits]="2" [useGrouping]="true"
                [style]="{'width':'100%','height':'32px','font-size':'16px'}">
              </p-inputNumber>
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="vinCustomerPriceEdit">{{
                'TRANSLATE.TWO.POINTS.FINAL.CLIENT.PRICE' | translate
                }}</label><br />

              <p-inputNumber [disabled]="isEditBlockDisabled" id="vinCustomerPriceEdit"
                [(ngModel)]="filterContractSearchResult.vinCustomerPrice" mode="decimal" [currency]="undefined"
                [locale]="'pt-BR'" [minFractionDigits]="2" [maxFractionDigits]="2" [useGrouping]="true"
                [style]="{'width':'100%','height':'32px','font-size':'16px'}">
              </p-inputNumber>
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="refundsForCustomersEdit">{{ 'TRANSLATE.REFOUNDS' | translate
                }}</label><br />

              <p-inputNumber [disabled]="isEditBlockDisabled" id="refundsForCustomersEdit"
                [(ngModel)]="filterContractSearchResult.refundsForCustomers" mode="decimal" [currency]="undefined"
                [locale]="'pt-BR'" [minFractionDigits]="2" [maxFractionDigits]="2" [useGrouping]="true"
                [style]="{'width':'100%','height':'32px','font-size':'16px'}">
              </p-inputNumber>

            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="coverageCategoryEdit">{{ 'TRANSLATE.TWO.POINTS.COVERAGE.CATEGORY'
                | translate
                }}</label><br />
              <input pInputText [disabled]="isEditBlockDisabled" id="coverageCategoryEdit"
                [(ngModel)]="filterContractSearchResult.coverageCategory" type="text" maxlength="50"
                style="width: 100%" />
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="coverageCodeEdit">{{ 'TRANSLATE.TWO.POINTS.COVERAGE.CODE' |
                translate }}</label><br />
              <input pInputText [disabled]="isEditBlockDisabled" id="coverageCodeEdit"
                [(ngModel)]="filterContractSearchResult.coverageCode" type="text" maxlength="4" style="width: 100%" />
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="coverageDescriptionEdit">{{
                'TRANSLATE.TWO.POINTS.COVERAGE.DESCRIPTION' | translate
                }}</label><br />
              <input pInputText [disabled]="isEditBlockDisabled" id="coverageDescriptionEdit"
                [(ngModel)]="filterContractSearchResult.coverageDescription" type="text" maxlength="100"
                style="width: 100%" />
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="coverageNameEdit">{{ 'TRANSLATE.TWO.POINTS.COVERAGE.NAME' |
                translate }}</label><br />
              <input pInputText [disabled]="isEditBlockDisabled" id="coverageNameEdit"
                [(ngModel)]="filterContractSearchResult.coverageName" type="text" maxlength="20" style="width: 100%" />
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="coverageMonthsEdit">{{ 'TRANSLATE.TWO.POINTS.COVERAGE.MONTHS' |
                translate }}</label><br />
              <input pInputText [disabled]="isEditBlockDisabled" id="coverageMonthsEdit"
                [(ngModel)]="filterContractSearchResult.coverageMonths" type="text" maxlength="3" style="width: 100%" />
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="coverageKm">{{ 'TRANSLATE.TWO.POINTS.COVERAGE.KILOMETERS' |
                translate
                }}</label><br />
              <p-inputNumber [disabled]="isEditDisabled" [(ngModel)]="editingCoverageKm" mode="decimal"
                inputId="coverageKm" [useGrouping]="true" [maxFractionDigits]="0" [locale]="'pt-BR'" maxlength="12"
                [style]="{'width':'100%','height':'32px','font-size':'16px'}">
              </p-inputNumber>

            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="coverageStartVisit">{{
                'TRANSLATE.TWO.POINTS.ACCOUNTANT.INITIAL.VISIT' | translate
                }}</label><br />
              <p-inputNumber [disabled]="isEditDisabled" [(ngModel)]="editingCoverageStartVisit" mode="decimal"
                inputId="coverageStartVisit" [useGrouping]="false" [maxFractionDigits]="0" [locale]="'pt-BR'" [max]="99"
                (keydown)="restrictCoverageStartVisitKeypress($event)" (blur)="checkCoverageStartVisit()"
                [style]="{'width':'100%','height':'32px','font-size':'16px'}" required>
              </p-inputNumber>

              @if (isEditingMode && hasAttemptedSave && requiredCoverageStartVisit === true) {
              <p-message class="client-data-message" severity="error"
                text="{{ 'TRANSLATE.ENTER.THE.VALUE.OF.THE.FIELD' | translate }}">
              </p-message>
              }

            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="coverageVisitLimit">{{ 'TRANSLATE.TWO.POINTS.VISIT.LIMIT' |
                translate }}</label><br />
              <input pInputText [disabled]="isEditBlockDisabled" id="coverageVisitLimit"
                [(ngModel)]="filterContractSearchResult.coverageVisitLimit" type="text" maxlength="2"
                style="width: 100%" />
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="coverageVisitorCounter">{{ 'TRANSLATE.TWO.POINTS.VISITOR.COUNTER'
                | translate }}</label><br />

              <p-inputNumber [disabled]="isEditDisabled" [(ngModel)]="editingCoverageVisitorCounter" mode="decimal"
                inputId="coverageVisitorCounter" [useGrouping]="false" [maxFractionDigits]="0" [locale]="'pt-BR'"
                [max]="999999999999" (keydown)="restrictCoverageVisitorCounterKeypress($event)"
                (blur)="checkCoverageVisitorCounter()" [style]="{'width':'100%','height':'32px','font-size':'16px'}"
                required>
              </p-inputNumber>

              @if (isEditingMode && hasAttemptedSave && requiredCoverageVisitorCounter === true) {
              <p-message class="client-data-message" severity="error"
                text="{{ 'TRANSLATE.ENTER.THE.VALUE.OF.THE.FIELD' | translate }}">
              </p-message>
              }
            </div>
          </div>
        </p-accordionTab>

        @if (systemCountry === 'BRA' && canceledContractInformation) {
        <p-accordionTab header="{{ 'TRANSLATE.CANCELLATION.REQUEST.DATA' | translate }}">
          <div class="grid ui-fluid">
            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="cancellationDateEdit">{{ 'TRANSLATE.CANCELLATION.DATE' |
                translate
                }}</label><br />
              <p-calendar [disabled]="isEditBlockDisabled" id="cancellationDateEdit" [(ngModel)]="cancellationDate"
                dateFormat="dd/mm/yy" [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}"></p-calendar>
            </div>
            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="incurredMonthsEdit">{{ 'TRANSLATE.MONTHS.ELAPSED' | translate
                }}</label><br />
              <input pInputText [disabled]="isEditBlockDisabled" id="incurredMonthsEdit"
                [(ngModel)]="canceledContractInformation.incurredMonths" type="text" maxlength="5"
                style="width: 100%" />
            </div>
            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="informedKm">{{ 'TRANSLATE.KM.INFORMED' | translate
                }}</label><br />
              <p-inputNumber [disabled]="isEditBlockDisabled" [(ngModel)]="canceledContractInformation.informedKm"
                mode="decimal" inputId="informedKm" [useGrouping]="true" [maxFractionDigits]="0" [locale]="'pt-BR'"
                maxlength="12" [style]="{'width':'100%','height':'32px','font-size':'16px'}">
              </p-inputNumber>
            </div>
            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="indexIPCAEdit">{{ 'TRANSLATE.IPCA.RATE' | translate
                }}</label><br />
              <input pInputText [disabled]="isEditBlockDisabled" id="indexIPCAEdit"
                [(ngModel)]="canceledContractInformation.indexTax" type="text" maxlength="6" style="width: 100%" />
            </div>
            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="adminTaxEdit">{{ 'TRANSLATE.ADMINISTRATIVE.FREE' | translate
                }}</label><br />
              <input pInputText [disabled]="isEditBlockDisabled" id="adminTaxEdit"
                [(ngModel)]="canceledContractInformation.adminTax" type="text" maxlength="13" style="width: 100%" />
            </div>
            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="finalPriceReturn">{{ 'TRANSLATE.FINAL.PRICE.RETURN' | translate
                }}</label><br />
              <p-inputNumber [disabled]="editableCancellationField" id="finalPriceReturn"
                [(ngModel)]="cancelledTotalValueEdit" mode="decimal" [currency]="undefined" [locale]="'pt-BR'"
                [minFractionDigits]="2" [maxFractionDigits]="2" [useGrouping]="true"
                (ngModelChange)="onCancelledTotalValueChange($event)"
                [style]="{'width':'100%','height':'32px','font-size':'16px'}">
              </p-inputNumber>
              @if (isEditingMode && hasAttemptedSave && totalValueObligatory === true) {
              <p-message class="client-data-message" severity="error"
                text="{{ 'TRANSLATE.ENTER.THE.VALUE.OF.THE.FIELD' | translate }}">
              </p-message>
              }
            </div>
            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="fordPriceReturn">{{ 'TRANSLATE.FORD.PRICE.RETURN' | translate
                }}</label><br />
              <p-inputNumber [disabled]="editableCancellationField" id="fordPriceReturn"
                [(ngModel)]="cancelledFordValueEdit" mode="decimal" [currency]="undefined" [locale]="'pt-BR'"
                [minFractionDigits]="2" [maxFractionDigits]="2" [useGrouping]="true"
                (ngModelChange)="onCancelledFordValueChange($event)"
                [style]="{'width':'100%','height':'32px','font-size':'16px'}">
              </p-inputNumber>
              @if (isEditingMode && hasAttemptedSave && fordValueObligatory === true) {
              <p-message class="client-data-message" severity="error"
                text="{{ 'TRANSLATE.ENTER.THE.VALUE.OF.THE.FIELD' | translate }}">
              </p-message>
              }
            </div>
            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="dealerPriceReturn">{{ 'TRANSLATE.DEALER.PRICE.RETURN' | translate
                }}</label><br />
              <p-inputNumber [disabled]="editableCancellationField" id="dealerPriceReturn"
                [(ngModel)]="cancelledDealerValueEdit" mode="decimal" [currency]="undefined" [locale]="'pt-BR'"
                [minFractionDigits]="2" [maxFractionDigits]="2" [useGrouping]="true"
                (ngModelChange)="onCancelledDealerValueChange($event)"
                [style]="{'width':'100%','height':'32px','font-size':'16px'}">
              </p-inputNumber>
              @if (isEditingMode && hasAttemptedSave && dealerValueObligatory === true) {
              <p-message class="client-data-message" severity="error"
                text="{{ 'TRANSLATE.ENTER.THE.VALUE.OF.THE.FIELD' | translate }}">
              </p-message>
              }
            </div>
          </div>
        </p-accordionTab>
        }

        <p-accordionTab header="{{ 'TRANSLATE.CONTRACT.NOTES' | translate }}">
          <div class="grid ui-fluid">
            <div class="col-12 md:col-12 lg:col-12">
              <textarea id="editingContractRemarks" pInputTextarea [disabled]="isEditDisabled"
                [(ngModel)]="editingContractRemarks" (ngModelChange)="onContractRemarksInput($event)" rows="5"
                maxlength="500" autoResize="false" style="width: 100%" (keyup)="textAreaCounterCaracteres()"></textarea>

              <div class="char-counter">
                {{ countCaracteresTextArea }} {{ 'TRANSLATE.MAX.CHARACTERS.500' | translate }}
              </div>

            </div>

            @if (isEditingMode && hasAttemptedSave && requiredContractNotes === true && !editingContractRemarks) {
            <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.ENTER.THE.VALUE.OF.THE.FIELD' | translate }}">
            </p-message>
            }
          </div>
        </p-accordionTab>
      </p-accordion>
    </div>

    <div class="col-12 contract-edit-actions">
      @if (!isEditingMode && isEditActionDisabledByCancellationState && editDisabledReasonKey) {
      <p-message class="contract-edit-disabled-reason" severity="warn" icon="pi pi-exclamation-triangle"
        [text]="(editDisabledReasonKey | translate)">
      </p-message>
      }
      @if (!isEditingMode) {
      <button pButton class="app-clean-button" (click)="buttonComeBack()" type="button" icon="pi pi-arrow-left"
        [disabled]="isSubmitted">
        {{ 'TRANSLATE.RETURN' | translate }}
      </button>
      }
      @if (!isEditingMode) {
      <button pButton class="app-filter-button" (click)="buttonEditarEnabled()" icon="pi pi-pencil" type="button"
        [disabled]="isPermissionButtonEditDisabled || isSubmitted || isEditActionDisabledByCancellationState">
        {{ 'TRANSLATE.EDIT' | translate }}
      </button>
      }
      @if (isEditingMode) {
      <button pButton class="app-clean-button" [disabled]="isSubmitted" icon="pi pi-times" type="button"
        (click)="buttonEditDisabled()">
        {{ 'TRANSLATE.CANCEL' | translate }}
      </button>
      }
      @if (isEditingMode) {
      <button pButton class="app-filter-button" [disabled]="isButtonSaveDisabled || isSubmitted"
        [attr.aria-busy]="isSubmitted" [icon]="isSubmitted ? 'pi pi-spin pi-spinner' : 'pi pi-check'" type="button"
        (click)="buttonSaveEdit()">
        {{ (isSubmitted ? 'TRANSLATE.SAVING' : 'TRANSLATE.SAVE') | translate }}
      </button>
      }
    </div>
  </div>
</div>